import { render, staticRenderFns } from "./enquiryDetailCom.vue?vue&type=template&id=0164db5d&scoped=true"
import script from "./enquiryDetailCom.vue?vue&type=script&lang=js"
export * from "./enquiryDetailCom.vue?vue&type=script&lang=js"
import style0 from "./enquiryDetailCom.vue?vue&type=style&index=0&id=0164db5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164db5d",
  null
  
)

export default component.exports